import React, { useState } from "react";

export default function ManageHome() {
  const [formData, setFormData] = useState({
    hero: {
      title: "Empowering Businesses with Scalable Digital Solutions",
      subtitle:
        "We craft innovative web & mobile applications, deliver impactful marketing, and provide expert technical consulting to help your business thrive in the digital era.",
      bullets: [
        "✔ High-quality, scalable solutions",
        "✔ Experienced & certified team",
        "✔ Agile process with transparent communication",
      ],
      ctas: [
        { text: "Get Started", link: "/contact" },
        { text: "Explore Services", link: "/services" },
      ],
      image:
        "https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&w=1600",
    },

    whyChoose: [
      {
        title: "Expert Team",
        desc: "Certified developers & consultants with years of experience.",
        img: "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Agile Process",
        desc: "We follow agile methodology for faster delivery & adaptability.",
        img: "https://images.pexels.com/photos/3184328/pexels-photo-3184328.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Scalable Solutions",
        desc: "Our apps are designed to grow with your business.",
        img: "https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Global Clients",
        desc: "Trusted by startups and enterprises across 10+ countries.",
        img: "https://images.pexels.com/photos/3183170/pexels-photo-3183170.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
    ],

    about: {
      image:
        "https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=1600",
      text: "Dev Sols is a cutting-edge software house delivering scalable web apps, intuitive mobile experiences, and result-driven digital marketing strategies. Our team blends innovation with technical excellence.",
      mission: "To empower businesses with digital solutions that drive growth and innovation.",
      vision: "To be the trusted technology partner for companies worldwide.",
    },

    services: [
      {
        title: "Web Development",
        desc: "High-performance websites & web apps using modern tech.",
        img: "https://images.pexels.com/photos/3861972/pexels-photo-3861972.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Mobile Apps",
        desc: "Cross-platform iOS & Android apps with seamless UX.",
        img: "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Digital Marketing",
        desc: "Boost your online presence with SEO & social campaigns.",
        img: "https://images.pexels.com/photos/3184357/pexels-photo-3184357.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Tech Consulting",
        desc: "Get expert advice on scaling and optimizing your tech stack.",
        img: "https://images.pexels.com/photos/3184639/pexels-photo-3184639.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
    ],

    impact: [
      { num: "120+", text: "Projects Delivered" },
      { num: "50+", text: "Happy Clients" },
      { num: "10+", text: "Countries Served" },
    ],

    portfolio: [
      { title: "SaaS Platform", desc: "A scalable, high-performance solution tailored for our client’s needs.", img: "https://images.pexels.com/photos/3862372/pexels-photo-3862372.jpeg?auto=compress&cs=tinysrgb&w=800" },
      { title: "E-commerce Solution", desc: "Modern online shopping platform with seamless checkout.", img: "https://images.pexels.com/photos/3862372/pexels-photo-3862372.jpeg?auto=compress&cs=tinysrgb&w=800" },
      { title: "Mobile Banking App", desc: "Secure and intuitive mobile banking experience.", img: "https://images.pexels.com/photos/3862372/pexels-photo-3862372.jpeg?auto=compress&cs=tinysrgb&w=800" },
    ],

    testimonials: [
      {
        name: "Sarah Johnson",
        role: "Startup Founder",
        text: "Dev Sols delivered a flawless SaaS platform for our business. The team was professional and fast.",
        img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=200",
      },
      {
        name: "Michael Lee",
        role: "Tech Lead",
        text: "They truly understand modern technologies and delivered a high-quality mobile app on time.",
        img: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=200",
      },
      {
        name: "Anna Smith",
        role: "Marketing Manager",
        text: "Our digital presence grew significantly after their marketing campaign. Highly recommend!",
        img: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=200",
      },
    ],

    finalCTA: {
      title: "Ready to Transform Your Business?",
      subtitle: "Let’s build innovative, scalable digital solutions together. We’re here to turn your ideas into reality.",
      button: { text: "Contact Us Today", link: "/contact" },
    },
  });

  // Generic Update Helpers
  const updateField = (section, key, value) => {
    setFormData({ ...formData, [section]: { ...formData[section], [key]: value } });
  };

  const updateArrayItem = (section, idx, key, value) => {
    const arr = [...formData[section]];
    arr[idx][key] = value;
    setFormData({ ...formData, [section]: arr });
  };

  const addArrayItem = (section, newItem) => {
    setFormData({ ...formData, [section]: [...formData[section], newItem] });
  };

  const removeArrayItem = (section, idx) => {
    const arr = [...formData[section]];
    arr.splice(idx, 1);
    setFormData({ ...formData, [section]: arr });
  };

  const handleImageUpload = (section, idx, key, file) => {
    const url = URL.createObjectURL(file);
    if (typeof idx === "number") {
      updateArrayItem(section, idx, key, url);
    } else {
      updateField(section, key, url);
    }
  };

  const saveHomePage = () => {
    console.log("✅ Saving Home Page Content", formData);
    alert("✅ Home Page content saved! (Later connect to API)");
  };

  return (
    <div className="space-y-8 p-6">
      <h1 className="text-3xl font-bold">🏠 Edit Home Page</h1>

      {/* ✅ HERO SECTION */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Hero Section</h2>
        <input className="w-full border p-2 rounded" value={formData.hero.title} onChange={(e)=>updateField("hero","title",e.target.value)} />
        <textarea className="w-full border p-2 rounded" value={formData.hero.subtitle} onChange={(e)=>updateField("hero","subtitle",e.target.value)} />

        <h4 className="font-semibold">Bullets</h4>
        {formData.hero.bullets.map((b, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input className="flex-1 border p-2 rounded" value={b} onChange={(e)=>{
              const arr=[...formData.hero.bullets]; arr[i]=e.target.value; updateField("hero","bullets",arr);
            }} />
            <button onClick={()=>{const arr=[...formData.hero.bullets];arr.splice(i,1);updateField("hero","bullets",arr)}} className="bg-red-500 text-white px-3 rounded">❌</button>
          </div>
        ))}
        <button className="bg-blue-500 text-white px-3 py-1 rounded" onClick={()=>updateField("hero","bullets",[...formData.hero.bullets,"New Bullet"])}>➕ Add Bullet</button>

        <h4 className="font-semibold mt-4">Hero Image</h4>
        {formData.hero.image && <img src={formData.hero.image} alt="hero" className="w-64 rounded mb-2" />}
        <input type="file" accept="image/*" onChange={(e)=>handleImageUpload("hero",null,"image",e.target.files[0])} />
      </section>

      {/* ✅ WHY CHOOSE US */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Why Choose Us</h2>
        {formData.whyChoose.map((f,i)=>(
          <div key={i} className="border p-3 rounded space-y-2">
            <input className="w-full border p-2 rounded" value={f.title} onChange={(e)=>updateArrayItem("whyChoose",i,"title",e.target.value)} />
            <textarea className="w-full border p-2 rounded" value={f.desc} onChange={(e)=>updateArrayItem("whyChoose",i,"desc",e.target.value)} />
            {f.img && <img src={f.img} className="w-48 rounded" />}
            <input type="file" onChange={(e)=>handleImageUpload("whyChoose",i,"img",e.target.files[0])}/>
            <button onClick={()=>removeArrayItem("whyChoose",i)} className="bg-red-500 text-white px-3 py-1 rounded">❌ Remove</button>
          </div>
        ))}
        <button onClick={()=>addArrayItem("whyChoose",{title:"",desc:"",img:""})} className="bg-blue-500 text-white px-3 py-1 rounded">➕ Add Feature</button>
      </section>

      {/* ✅ ABOUT SECTION */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">About Section</h2>
        {formData.about.image && <img src={formData.about.image} className="w-64 rounded" />}
        <input type="file" onChange={(e)=>handleImageUpload("about",null,"image",e.target.files[0])} />
        <textarea className="w-full border p-2 rounded" value={formData.about.text} onChange={(e)=>updateField("about","text",e.target.value)} />
        <input className="w-full border p-2 rounded" value={formData.about.mission} onChange={(e)=>updateField("about","mission",e.target.value)} />
        <input className="w-full border p-2 rounded" value={formData.about.vision} onChange={(e)=>updateField("about","vision",e.target.value)} />
      </section>

      {/* ✅ SERVICES */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Services</h2>
        {formData.services.map((s,i)=>(
          <div key={i} className="border p-3 rounded space-y-2">
            <input className="w-full border p-2 rounded" value={s.title} onChange={(e)=>updateArrayItem("services",i,"title",e.target.value)} />
            <textarea className="w-full border p-2 rounded" value={s.desc} onChange={(e)=>updateArrayItem("services",i,"desc",e.target.value)} />
            {s.img && <img src={s.img} className="w-48 rounded" />}
            <input type="file" onChange={(e)=>handleImageUpload("services",i,"img",e.target.files[0])}/>
            <button onClick={()=>removeArrayItem("services",i)} className="bg-red-500 text-white px-3 py-1 rounded">❌ Remove</button>
          </div>
        ))}
        <button onClick={()=>addArrayItem("services",{title:"",desc:"",img:""})} className="bg-blue-500 text-white px-3 py-1 rounded">➕ Add Service</button>
      </section>

      {/* ✅ IMPACT NUMBERS */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Impact Numbers</h2>
        {formData.impact.map((n,i)=>(
          <div key={i} className="flex gap-2">
            <input className="w-24 border p-2 rounded" value={n.num} onChange={(e)=>updateArrayItem("impact",i,"num",e.target.value)} />
            <input className="flex-1 border p-2 rounded" value={n.text} onChange={(e)=>updateArrayItem("impact",i,"text",e.target.value)} />
            <button onClick={()=>removeArrayItem("impact",i)} className="bg-red-500 text-white px-3 rounded">❌</button>
          </div>
        ))}
        <button onClick={()=>addArrayItem("impact",{num:"",text:""})} className="bg-blue-500 text-white px-3 py-1 rounded">➕ Add Stat</button>
      </section>

      {/* ✅ PORTFOLIO */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Portfolio</h2>
        {formData.portfolio.map((p,i)=>(
          <div key={i} className="border p-3 rounded space-y-2">
            <input className="w-full border p-2 rounded" value={p.title} onChange={(e)=>updateArrayItem("portfolio",i,"title",e.target.value)} />
            <textarea className="w-full border p-2 rounded" value={p.desc} onChange={(e)=>updateArrayItem("portfolio",i,"desc",e.target.value)} />
            {p.img && <img src={p.img} className="w-48 rounded" />}
            <input type="file" onChange={(e)=>handleImageUpload("portfolio",i,"img",e.target.files[0])}/>
            <button onClick={()=>removeArrayItem("portfolio",i)} className="bg-red-500 text-white px-3 py-1 rounded">❌ Remove</button>
          </div>
        ))}
        <button onClick={()=>addArrayItem("portfolio",{title:"",desc:"",img:""})} className="bg-blue-500 text-white px-3 py-1 rounded">➕ Add Project</button>
      </section>

      {/* ✅ TESTIMONIALS */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Testimonials</h2>
        {formData.testimonials.map((t,i)=>(
          <div key={i} className="border p-3 rounded space-y-2">
            <input className="w-full border p-2 rounded" value={t.name} onChange={(e)=>updateArrayItem("testimonials",i,"name",e.target.value)} />
            <input className="w-full border p-2 rounded" value={t.role} onChange={(e)=>updateArrayItem("testimonials",i,"role",e.target.value)} />
            <textarea className="w-full border p-2 rounded" value={t.text} onChange={(e)=>updateArrayItem("testimonials",i,"text",e.target.value)} />
            {t.img && <img src={t.img} className="w-24 h-24 rounded-full" />}
            <input type="file" onChange={(e)=>handleImageUpload("testimonials",i,"img",e.target.files[0])}/>
            <button onClick={()=>removeArrayItem("testimonials",i)} className="bg-red-500 text-white px-3 py-1 rounded">❌ Remove</button>
          </div>
        ))}
        <button onClick={()=>addArrayItem("testimonials",{name:"",role:"",text:"",img:""})} className="bg-blue-500 text-white px-3 py-1 rounded">➕ Add Testimonial</button>
      </section>

      {/* ✅ FINAL CTA */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Final CTA</h2>
        <input className="w-full border p-2 rounded" value={formData.finalCTA.title} onChange={(e)=>updateField("finalCTA","title",e.target.value)} />
        <textarea className="w-full border p-2 rounded" value={formData.finalCTA.subtitle} onChange={(e)=>updateField("finalCTA","subtitle",e.target.value)} />
        <input className="w-full border p-2 rounded" value={formData.finalCTA.button.text} onChange={(e)=>{
          updateField("finalCTA","button",{...formData.finalCTA.button,text:e.target.value});
        }} />
        <input className="w-full border p-2 rounded" value={formData.finalCTA.button.link} onChange={(e)=>{
          updateField("finalCTA","button",{...formData.finalCTA.button,link:e.target.value});
        }} />
      </section>

      {/* ✅ SAVE BUTTON */}
      <div className="text-center">
        <button onClick={saveHomePage} className="bg-green-500 text-white px-6 py-3 rounded font-bold">
          ✅ Save Home Page
        </button>
      </div>
    </div>
  );
}
